import Layout1x1 from 'components/Layout1x1';
import Line from 'components/Line';
import Link from 'next/link';

const ShoesAndSocksCopy = () => (
  <>
    <Layout1x1>
      <h3 className="text-h2">About Our Suit and Tuxedo Shoes and Socks</h3>
      <Line />
      <p>Shoes and socks shouldn't be a forgotten part of your formalwear. They can make or break your suit or tuxedo look.</p>
    </Layout1x1>

    <Layout1x1 className="mt-56">
      <h3 className="text-h2">Dress Shoe Styles and Colors</h3>
      <p>
        Generation Tux carries both regular synthetic leather dress shoes for men and synthetic{' '}
        <Link
          href="/collection/shoes-and-socks/glossy-black-tuxedo-shoes"
          replace={true}
          className="tracker-text-collection-glossy_black_shoes-221228-105100"
        >
          patent leather shoes
        </Link>
        . In both brown and black leather, you'll find the perfect shoe for both suits and tuxedos.
      </p>
    </Layout1x1>

    <Layout1x1 className="mt-56">
      <h3 className="text-h2">Dress Socks</h3>
      <p>
        Tuxedo socks don't have to be just plain black. Add a pop of color and playfulness to your look with patterned socks. From{' '}
        <Link
          href="/collection/shoes-and-socks?pattern=Striped"
          replace={true}
          className="tracker-text-collection-striped_shoes-221228-105200"
        >
          stripes
        </Link>
        , to polka dots, florals, and even your favorite team, you show off your personality with your socks.
      </p>
    </Layout1x1>
  </>
);

export default ShoesAndSocksCopy;
